//import { Platform } from 'react-native'
//import Modal from 'react-native-modal'
import { Button, YStack, SimpleText, View, XPModal } from '@my/ui'

interface ConfirmationModalProps {
  icon?: React.ReactNode
  image?: React.ReactNode
  text: string
  modal: boolean
  onClose: () => void
  onConfirm: () => void
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  icon,
  image,
  text,
  modal,
  onClose,
  onConfirm,
}) => {
  return (
    <XPModal
      open={modal}
      onBackgroundPress={onClose}
      otherProps={{
        style: { justifyContent: 'center', alignItems: 'center' },
        animationIn: 'fadeIn',
        animationOut: 'fadeOut',
        backdropOpacity: 0.7 // Platform.OS === 'web' ? 0.3 : 0.7
      }}
      nativeModalType={'library'}
    >
      <YStack
        backgroundColor="#fff"
        borderRadius={12}
        gap={20}
        padding={20}
        alignItems="center"
        $platform-native={{
          width: '100%',
        }}
      >
        <View width="100%" alignItems="center" gap={20}>
          <View style={{ alignItems: 'center' }}>{icon ? icon : image}</View>
          <SimpleText
            fontSize={17}
            fontWeight="700"
            color="#63995D"
            textAlign="center"
            width="70%"
            lineHeight={24}
          >
            Are you sure you want to {text}?
          </SimpleText>
        </View>
        <YStack width="100%" alignItems="center" gap={10}>
          <Button onPress={onClose} pressStyle={{ opacity: 0.5 }} unstyled justifyContent="center">
            <SimpleText fontSize={17} fontWeight="400" color="#000" lineHeight={24}>
              Cancel
            </SimpleText>
          </Button>
          <View width="90%" height={1} backgroundColor="rgba(99, 153, 93, 0.33)" />
          <Button
            onPress={onConfirm}
            pressStyle={{ opacity: 0.5 }}
            unstyled
            justifyContent="center"
          >
            <SimpleText fontWeight="700" fontSize={17} color="#63995D" lineHeight={24}>
              Ok
            </SimpleText>
          </Button>
        </YStack>
      </YStack>
    </XPModal>
  )
}

export default ConfirmationModal
